import * as Yup from "yup"
import React, { useMemo } from "react"
import { useGetDealDoneByUsersQuery } from "../../../../../pages/Common/commonService"
import { FormPageProps } from "../../.."
import { TStore } from "../../../../../store/Store"
import { useSelector } from "react-redux"
import { useFormik } from "formik"
import { DropdownObj } from "../../../../../pages/Common/commonTypes"
import { useAddEvInfraTicketMutation } from "../../../../../pages/Operations/features/EVApplication/EVApplicationService"
import { EAccountRole } from "../../../../../enums/commonEnums"
import { APP_ROUTES } from "routes/AppRoutes"

const validationSchema: (values: any, isOutright: boolean) => Yup.ObjectSchema<any> = (values, isOutright) =>
    Yup.object().shape({
        project_name: Yup.string().required("Project Name is required"),
        business_poc: Yup.object()
            .shape({
                id: Yup.number().required("Business POC is required"),
                title: Yup.string().required("Business POC is required"),
            })
            .required("Business POC is required"),
        electricity_bill: Yup.mixed().required("Electricity Bill is required"),
        property_ownership_proof: Yup.mixed().required("Property Ownership Proof is required"),
        deal_docs: Yup.mixed().required("Other Documents is required"),
        noc: Yup.mixed().required("NOC is required"),
        agreement_report: Yup.mixed().required("Agreement is required"),
        purchase_order: isOutright ? Yup.mixed().required("PO is required") : Yup.mixed().nullable(),
    })

const useEvInfra = (props: FormPageProps) => {
    const { data: dealDoneByUsersList } = useGetDealDoneByUsersQuery()
    const { user_id } = useSelector((state: any) => state.verifyLogin)

    const { deal_sow_form, sites_form_demolition } = useSelector((state: TStore) => state.RaiseTicketForm)

    const [addEvInfraTicket, { isLoading }] = useAddEvInfraTicketMutation()
    const isOutright = deal_sow_form.deal_type?.title === "Outright"

    const handleSubmit = async (values: any) => {
        if (isLoading) return
        const accountPayload = Object.keys(sites_form_demolition.accountFormMap).map(key => ({
            account_id: sites_form_demolition?.accountFormMap[key as EAccountRole]?.accountId?.id?.toString()!,
            account_role: key,
            billing_address_id:
                sites_form_demolition?.accountFormMap[key as EAccountRole]?.billingAddress?.id?.toString()!,
            contact_id: sites_form_demolition?.accountFormMap[key as EAccountRole]?.billingContact?.id?.toString()!,
        }))
        const formData = new FormData()
        formData.append("project_name", values.project_name)
        formData.append("business_poc_id", values.business_poc.id)
        formData.append("deal_type", deal_sow_form.deal_type?.title)
        formData.append("account_details", JSON.stringify(accountPayload))
        formData.append("site_id", sites_form_demolition.sourceSite?.id?.toString()!)

        for (let i = 0; i < values.electricity_bill?.length; i++) {
            formData.append("electricity_bill", values.electricity_bill[i])
        }
        for (let i = 0; i < values.property_ownership_proof?.length; i++) {
            formData.append("property_ownership_proof", values.property_ownership_proof[i])
        }
        for (let i = 0; i < values.deal_docs?.length; i++) {
            formData.append("deal_docs", values.deal_docs[i])
        }
        for (let i = 0; i < values.noc?.length; i++) {
            formData.append("noc", values.noc[i])
        }
        for (let i = 0; i < values.agreement_report?.length; i++) {
            formData.append("agreement_report", values.agreement_report[i])
        }
        for (let i = 0; i < values.purchase_order?.length; i++) {
            formData.append("purchase_order", values.purchase_order[i])
        }
        await addEvInfraTicket(formData)
        if (props.redirectPage) {
            window.open(APP_ROUTES.EV_APPLICATION_LIST, "_blank")
        }
        props.handleCloseForm?.()
    }

    const formik = useFormik<any>({
        initialValues: {
            project_name: "",
            business_poc: {} as DropdownObj,
            electricity_bill: null,
            property_ownership_proof: null,
            deal_docs: null,
            noc: null,
            agreement_report: null,
            purchase_order: null,
        },
        validationSchema: Yup.lazy((values: any) => validationSchema(values, isOutright)),
        onSubmit: handleSubmit,
    })

    const handleAssignToMe = () => {
        formik.setFieldValue("business_poc", {
            id: user_id,
            title: dealDoneByUsersList?.find((dealDoneByUser: any) => dealDoneByUser.id === user_id)?.name,
        })
    }

    const dealDoneByUsersOptions = useMemo(() => {
        return dealDoneByUsersList?.map((dealDoneByUser: any) => ({
            id: dealDoneByUser.id,
            title: dealDoneByUser.name,
        }))
    }, [dealDoneByUsersList])

    return { dealDoneByUsersOptions, formik, isOutright, isLoading, handleAssignToMe }
}

export default useEvInfra
